import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { defaultLocale, locales, translations } from './translations';

function getNested(obj, path) {
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

const LocaleContext = createContext({
    locale: defaultLocale,
    setLocale: () => {},
    t: () => '',
    locales,
});

export function LocaleProvider({ children }) {
    const [locale, setLocaleState] = useState(() => {
        if (typeof window === 'undefined') return defaultLocale;
        const saved = localStorage.getItem('app-locale');
        return saved && translations[saved] ? saved : defaultLocale;
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('app-locale', locale);
        }
    }, [locale]);

    const setLocale = useCallback((code) => {
        if (translations[code]) {
            setLocaleState(code);
        }
    }, []);

    const t = useCallback(
        (key) => {
            const value = getNested(translations[locale], key);
            return value !== undefined ? value : key;
        },
        [locale]
    );

    return (
        <LocaleContext.Provider value={{ locale, setLocale, t, locales }}>
            {children}
        </LocaleContext.Provider>
    );
}

export function useLocale() {
    const ctx = useContext(LocaleContext);
    if (!ctx) {
        throw new Error('useLocale must be used within a LocaleProvider');
    }
    return ctx;
}
